// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"3059981c","417":"56ab6f63","618":"57ffa136"}[chunkId] + ".chunk.js";
};